import React from "react";

function DashFooter(props) {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <p>copyright © {currentYear} MarkNotes - S.W. Chiu</p>
    </footer>
  );
}
export default DashFooter;
